import Vue from "vue";
import BeautifulChat from "vue-beautiful-chat";
import VueCropper from "vue-cropper";
import { importAll } from "@/utils";
import "./antd";
import "./material";
import "./swiper";

const requireContext = require.context("./", true, /\.vue$/);
const components = importAll(requireContext);

for (const key in components) {
  Vue.component(components[key].options.name, components[key]);
}

Vue.use(BeautifulChat);
Vue.use(VueCropper);
